/**
 * Purpose: Mount an Open-Meteo raster source/layer from an om:// URL.
 * Assumptions: om protocol is registered once globally and URL points to Open-Meteo map-tile resources.
 * External refs: src/external/weather-map-layer (vendored @openmeteo/weather-map-layer@0.0.19) omProtocol, maplibre addProtocol, react-map-gl/maplibre.
 */
import { omProtocol } from "@openmeteo/weather-map-layer";
import maplibregl from "maplibre-gl";
import { Layer, Source } from "react-map-gl/maplibre";

declare global {
  var __openMeteoProtocolRegistered__: boolean | undefined;
}

if (!globalThis.__openMeteoProtocolRegistered__) {
  maplibregl.addProtocol("om", omProtocol);
  globalThis.__openMeteoProtocolRegistered__ = true;
}

type OpenMeteoRasterLayerProps = {
  id: string;
  url: string;
  opacity?: number;
};

export function OpenMeteoRasterLayer({
  id,
  url,
  opacity = 0.72,
}: OpenMeteoRasterLayerProps) {
  return (
    <Source
      id={`${id}-source`}
      key={url}
      type="raster"
      url={`om://${url}`}
      maxzoom={12}
    >
      <Layer
        id={`${id}-layer`}
        type="raster"
        paint={{
          "raster-opacity": opacity,
        }}
      />
    </Source>
  );
}
